module.exports = __webpack_public_path__ + "img/case6.a5564bcb.jpg";